import { Box, Button, Stack, Tooltip } from "@mui/material";
import AvatarMenu from "./AvatarMenu";
import QuickActions from "./QuickActions";
import { Menu, Wallet } from "@mui/icons-material";
import AddWalletModal from "../modals/AddWalletModal";
import { useState } from "react";
import { formatCompactINR, formatFullINR, useWalletBalance } from "../../hooks/useWalletBalance";



interface Props {
  /** Width taken by the desktop sidebar ("0px" on phones). */
  offset: string;
  showMenuButton: boolean;
  onMenuClick: () => void;
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

const TopBar = ({ offset, showMenuButton, onMenuClick }: Props) => {
  const [walletOpen, setWalletOpen] = useState(false);
const username = localStorage.getItem("hipship-username") || "User";
const isUser = username === "Cipla";
  // Shared with the Billing page and the recharge dialog; refreshes after a recharge.
  const { data: walletBalance = 0 } = useWalletBalance(!isUser);

  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: "60px",
        top: 0,
        zIndex: 1100,
        // backgroundColor: "#37bc9b ",
        backgroundColor: "#217aee ",
        boxShadow: "1px 2px 7px 0px rgba(0, 0, 0, 0.334)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
          gap: "30px",
          marginRight: "14px",
          marginLeft: offset === "0px" ? "4px" : `calc(${offset} + 8px)`,
          transition: "margin-left .25s ease",
        }}
      >
        <div>
          {showMenuButton && (
            <Button onClick={onMenuClick} sx={{ color: "#fff", minWidth: 0 }} aria-label="Open menu">
              <Menu />
            </Button>
          )}
        </div>
        <Stack direction={"row"} gap={"30px"}>
         {!isUser &&(
          <> 
          <Tooltip title={`Wallet balance: ${formatFullINR(walletBalance)} · Click to recharge`}>
          <Button
            onClick={() => setWalletOpen(true)}
            sx={{
              display: "flex",
              gap: "10px",
            }}
          >
            <Wallet
              sx={{
                color: "#fff",
              }}
            />
            <p
              style={{
                color: "#fff",
              }}
            >
              {formatCompactINR(walletBalance)}
            </p>
          </Button>
          </Tooltip></>)}
          <QuickActions />
          <AvatarMenu />
        </Stack>
      </Box>
      <AddWalletModal
        open={walletOpen}
        handleClose={() => setWalletOpen(false)}
      />
    </div>
  );
};

export default TopBar;
